// extracted by mini-css-extract-plugin
export var option = "_95-0";
export var optionCard = "_95-f";
export var optionContent = "_95-g";
export var optionIcon = "_95-i";
export var optionIconBox = "_95-h";
export var optionLabel = "_95-j";
export var optionPill = "_95-m";
export var optionPillBadge = "_95-p";
export var optionPillIcon = "_95-n";
export var optionPillLabel = "_95-o";
export var optionRadio = "_95-k";
export var optionRadioInner = "_95-l";
export var optionReveal = "_95-2";
export var optionRevealDelay0 = "_95-3";
export var optionRevealDelay1 = "_95-4";
export var optionRevealDelay10 = "_95-d";
export var optionRevealDelay11 = "_95-e";
export var optionRevealDelay2 = "_95-5";
export var optionRevealDelay3 = "_95-6";
export var optionRevealDelay4 = "_95-7";
export var optionRevealDelay5 = "_95-8";
export var optionRevealDelay6 = "_95-9";
export var optionRevealDelay7 = "_95-a";
export var optionRevealDelay8 = "_95-b";
export var optionRevealDelay9 = "_95-c";
export var optionSelected = "_95-1";